'use strict';

namespace Core {

    class CanonicalTag {

        constructor(
        private $element: HTMLLinkElement,
        private $rootScope: ng.IRootScopeService) {

            $rootScope.$watch(() => {
                if ($element[0].href !== location.href) {
                    $element[0].href = location.href;
                    $element[0].href = $element[0].href.split('?')[0];
                }
            });

            $rootScope.$watch('canonicalSuffix', (val, old) => {
                if (val !== old && $element && $element[0] && $element[0].href) {
                    $element[0].href = $element[0].href.split('?')[0] + val;
                }
            });

        }
    };

    angular
        .module('core')
        .directive('canonicalTag', (): ng.IDirective => {
            return {
                restrict: 'A',
                controller: CanonicalTag,
                bindToController: true
            };
        });
}
